import Provider from './Provider';
import connect from './connect';
import createComponent from './createComponent';
import createComponentWithProxy from './createComponentWithProxy';
import ThemeProvider from './ThemeProvider';

export { Provider, connect, createComponent, createComponentWithProxy, ThemeProvider };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-fela/es/index.js
// module id = 269
// module chunks = 0